import React from 'react';
import {Select} from "antd";
import GEOGRAPHICAL_STATES from "./geographicalStates";

interface Props {
    onChange?:()=>void,
    value?:any,
    disabled?:boolean,
}

function GeographicalStatesSelect({ onChange, value, disabled }:Props){
    return (
        <Select size='large' mode='multiple' value={value} onChange={onChange} optionLabelProp='children' allowClear disabled={disabled}>
            {Object.keys(GEOGRAPHICAL_STATES).map(state => {
                return (
                    <Select.Option key={state} value={state}>
                        {state} - {GEOGRAPHICAL_STATES[state]}
                    </Select.Option>
                )
            })}
        </Select>
    )
}

export default GeographicalStatesSelect;